import * as Types from '../../../../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InviteChangedSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InviteChangedSubscriptionQuery = { __typename: 'Subscription', inviteUpdate: { __typename: 'InviteUpdatePayload', inviteId: string, projectId: string, userId: string, status: string } };


export const InviteChangedSubscriptionQueryDocument = gql`
    subscription inviteChangedSubscriptionQuery {
  inviteUpdate {
    ... on InviteUpdatePayload {
      inviteId
      projectId
      userId
      status
    }
  }
}
    `;

/**
 * __useInviteChangedSubscriptionQuery__
 *
 * To run a query within a React component, call `useInviteChangedSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteChangedSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteChangedSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useInviteChangedSubscriptionQuery(baseOptions?: Apollo.SubscriptionHookOptions<InviteChangedSubscriptionQuery, InviteChangedSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InviteChangedSubscriptionQuery, InviteChangedSubscriptionQueryVariables>(InviteChangedSubscriptionQueryDocument, options);
      }
export type InviteChangedSubscriptionQueryHookResult = ReturnType<typeof useInviteChangedSubscriptionQuery>;